export const createLockIcon = (bbox, centerX, centerY) => {
    // Fixed icon size at 24px
    const iconSize = 24;
    const lockGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    lockGroup.classList.add("insufficient-ladies-warning");
    lockGroup.setAttribute("pointer-events", "none");
    const bgCircle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    bgCircle.setAttribute("cx", String(centerX));
    bgCircle.setAttribute("cy", String(centerY));
    bgCircle.setAttribute("r", String(iconSize * 0.4)); // Circle radius
    bgCircle.setAttribute("fill", "#D84444");
    bgCircle.setAttribute("filter", "drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5))");
    const lockIcon = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const scale = iconSize / 48; // Dynamic scale based on icon size
    const offsetX = centerX - 12 * scale;
    const offsetY = centerY - 12 * scale;
    lockIcon.setAttribute("d", "M12 1C14.7614 1 17 3.23858 17 6V7H18C19.1046 7 20 7.89543 20 9V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H7V6C7 3.23858 9.23858 1 12 1ZM15 7V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V7H15ZM12 12C11.4477 12 11 12.4477 11 13V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13C13 12.4477 12.5523 12 12 12Z");
    lockIcon.setAttribute("fill", "white");
    lockIcon.setAttribute("transform", `translate(${offsetX}, ${offsetY}) scale(${scale})`);
    lockGroup.appendChild(bgCircle);
    lockGroup.appendChild(lockIcon);
    return lockGroup;
};
